import styles from './AboutPage.module.css';

const faqItems = [
  { question: 'Do you accept credit cards?', answer: 'Yes.' },
  { question: 'Do you take reservations?', answer: 'No, but we do offer private parties for larger gatherings.' },
  { question: "What time do you serve food 'til?", answer: '11:30, though subject to change based on demand.' },
  { question: 'Is the bar 21 plus?', answer: 'No persons under 21 are allowed to sit at the bar at anytime but before 6:00 pm all ages are welcome to sit at any table in the restaurant. After 6:00 minors must be accompanied by an adult. You must be 21+ to play pool or be in the pool area.' },
  { question: 'How many t.v.s do you have?', answer: 'A lot! There are two large projection screens in the main pool area and many big screens scattered throughout the rest of the bar.' },
  { question: 'Can you put my game on?', answer: "Most likely, if it's available. Please keep in mind that we can only show three different games at any given time." },
  { question: 'Do you have takeout?', answer: 'Yes' },
  { question: 'How much does pool cost?', answer: 'Pool tables are coin operated and are $2.00 a game, there are change machines located in the pool area. Pool tables are first come first serve.' },
  { question: 'Can I have a job?', answer: 'If you would like to apply for a job please come see us in person.' },
];

function AboutPage() {
  return (
    <div className={styles.page}>
      <section className={styles.about}>
        <h1 className={styles.aboutTitle}>See Yah Laatah&trade;!</h1>
        <article className={styles.aboutText}>
          <p>
            Nestled in the heart of downtown Boston and conveniently located on the famous Freedom Trail,
            Beantown is a classic American pub offering a casual drinking atmosphere and fine pub dining.
            Whether you're looking for an ice cold beer after work, a great place to meet friends, or
            somewhere to feel at home while you're traveling - Beantown Pub is the place to be!
          </p>
        </article>
      </section>

      <section className={styles.faq}>
        <h3 className={styles.faqTitle}>Frequently Asked Questions</h3>
        {faqItems.map((item) => (
          <div key={item.question} className={styles.faqItem}>
            <h4 className={styles.faqQuestion}>{item.question}</h4>
            <p className={styles.faqAnswer}>{item.answer}</p>
          </div>
        ))}
      </section>
    </div>
  );
}

export default AboutPage;
